import {_utils} from "../../../utils/_utils.js";
import {_libs} from "../../../utils/_libs.js";
import {Navigation, Pagination} from "swiper/modules";

export const testimonials = () => {
    return new Promise((resolve) => {
        _utils.initSection('.testimonials', (section) => init(section));
        resolve();
    })
}

const init = (section) => {
    const sliderEl = section.querySelector('.testimonials__slider');
    if (!sliderEl) return;

    const slides = sliderEl.querySelectorAll('.testimonials__slide');
    const logos = section.querySelectorAll('.testimonials__logo');
    const prevEl = section.querySelector('.testimonials__arrow--prev');
    const nextEl = section.querySelector('.testimonials__arrow--next');
    const paginationEl = section.querySelector('.testimonials__pagination');

    const setActiveLogo = (index) => {
        logos.forEach((logo) => {
            logo.classList.toggle('is-active', Number(logo.dataset.index) === index);
        });
    }

    // Single testimonial — no slider needed, the first logo stays active (set in markup).
    if (slides.length <= 1) return;

    _libs._swiper(sliderEl, {
        effect: 'fade',
        allowTouchMove: false,
        fadeEffect: {
            crossFade: true,
        },
        slidesPerView: 1,
        speed: 800,
        autoHeight: true,
        loop: false, // ends must be reachable so the nav arrows get .swiper-button-disabled
        keyboard: {
            enabled: true,
        },
        navigation: {
            prevEl,
            nextEl,
        },
        pagination: {
            el: paginationEl,
            type: 'fraction',
        },
        on: {
            init: (swiper) => {
                setActiveLogo(swiper.realIndex);
            },
            slideChange: (swiper) => {
                setActiveLogo(swiper.realIndex);
            },
        },
    });
}
